import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ReactDatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';
import { format } from 'date-fns/format';
import { parse } from 'date-fns/parse';
import { FormError } from './FormError';
import { useLanguageContext } from './LanguageContext';
const dateFormat = 'd.M.yyyy';
const parseDate = (value) => {
    const date = value ? parse(value, dateFormat, new Date()) : null;
    if (date?.toString() === 'Invalid Date') {
        return null;
    }
    return date;
};
export const DatePicker = ({ name, control, error }) => {
    const { language } = useLanguageContext();
    return (_jsxs("div", { children: [_jsx(Controller, { name: name, control: control, render: ({ field }) => (_jsx(ReactDatePicker, { id: name, locale: language, "aria-invalid": error ? 'true' : 'false', "aria-errormessage": `#error-${name}`, "aria-live": "polite", "aria-required": "true", selectsRange: false, selectsMultiple: false, onChange: (date) => field.onChange(date ? format(date, dateFormat) : null), selected: parseDate(field.value), dateFormat: dateFormat, className: error ? 'invalid_date' : '' })) }), _jsx(FormError, { id: `error-${name}`, error: error?.message, inputId: name })] }));
};
